import * as angular from "angular";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Filter } from "../../models/filter.model";
import { User } from "../../models/user.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { FilterDataProvider } from "../../data-provider/filter.dp";

let AdminCampaignsComponent = {
    selector: "vcAdminCampaigns",
    templateUrl: "/angular/components/admin/admin-campaigns.component.html",
    bindings: {},
    controller: class AdminCampaignsController {
        public filter: Filter;
        public user: User;
        public navigationBarService: NavigationBarHelperService;

        constructor(
            UserDataProvider: UserDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            FilterDataProvider: FilterDataProvider
        ) {
            this.navigationBarService = NavigationBarHelperService;
            this.user = UserDataProvider.getActiveUser();

            this.filter = FilterDataProvider.appliedFilter;
        }
    },
};

angular
    .module("admin", [
        "user",
        "nvd3",
        "ngMaterial",
        "angular-json-tree",
        "ngMaterialDateRangePicker",
    ])
    .component(AdminCampaignsComponent.selector, AdminCampaignsComponent);
